// @flow
import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import config from '../../config';

type Props = {
  isOpen: Boolean,
  close: () => void,
};

export default function BookingNotAvailableModal({ isOpen, close }: Props) {
  return (
    <Modal isOpen={isOpen} toggle={close}>
      <ModalHeader toggle={close}>
        Important Notice
      </ModalHeader>
      <ModalBody>
        <p>
          To book guides for these dates, please contact us directly via WhatsApp at{' '}
          <a href={`https://api.whatsapp.com/send?phone=${config.honeyguidePhoneNumber}`} style={{ color: '#00C0FF' }}>
            {config.honeyguidePhoneNumber}
          </a> or email us at {' '}
          <a href={`mailto:${config.honeyguideEmail}`} style={{ color: '#00C0FF' }}>
            {config.honeyguideEmail}
          </a>
        </p>
      </ModalBody>
    </Modal>
  );
};


// WEBPACK FOOTER //
// ./src/components/MessageModal/BookingNotAvailableModal.js